import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {parseUrl} from '../../functions/urlHash';

export interface SelectedProject {
    project_id: string;
    name: string;
}

interface ProjectState {
    selectedProject: SelectedProject | null;
}

const initialState: ProjectState = {
    selectedProject: (() => {
        const id = parseUrl().projectId;
        return id ? {project_id: id, name: id} : null;
    })(),
};

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setSelectedProject: (state, action: PayloadAction<SelectedProject | null>) => {
            state.selectedProject = action.payload;
        },
        clearSelectedProject: (state) => {
            state.selectedProject = null;
        },
    },
});

export const {setSelectedProject, clearSelectedProject} = projectSlice.actions;
export default projectSlice.reducer;
